import { useMemo } from 'react'
import type { FC } from 'react'
import { useSolutionDisplay } from './utils'
import { FaqsSection as BaseFaqsSection } from '~/structured_data/faqsection'
import type { ChakraProps } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

export function useFAQs(): { question: string; answer: string }[] {
	const { t } = useTranslation()
	const {
		location,
		cheapestSolution,
		smallestSolutionSize,
		largestSolutionSize,
	} = useSolutionDisplay()
	return useMemo(() => {
		if (
			!location ||
			!cheapestSolution ||
			!smallestSolutionSize ||
			!largestSolutionSize
		) {
			return []
		}
		const locationName = location.name
		return [
			{
				question: t('Hur mycket kostar {{location_name}}?', {
					location_name: locationName,
				}),
				answer: t(
					'Det kostar från {{cheapest_solution}}kr/person/månad att hyra kontor på {{location_name}}.',
					{ cheapest_solution: cheapestSolution, location_name: locationName }
				),
			},
			{
				question: t('Vilka kontor finns tillgängliga på {{location_name}}?', {
					location_name: locationName,
				}),
				answer:
					smallestSolutionSize == 0
						? t(
								'Just nu finns det inte några lediga kontor på {{location_name}}.',
								{ location_name: locationName }
						  )
						: t(
								'Det finns lediga kontor från {{smallest_solution_size}} {{unit}} - {{largest_solution_size}} arbetsplatser.',
								{
									smallest_solution_size: smallestSolutionSize,
									unit: t('Arbetsplats', {
										count: smallestSolutionSize,
									}).toLocaleLowerCase(),
									largest_solution_size: largestSolutionSize,
								}
						  ),
			},
		]
	}, [location, cheapestSolution, smallestSolutionSize, largestSolutionSize, t])
}

export const FaqsSection: FC<ChakraProps> = ({ ...rest }) => {
	const FAQs = useFAQs()
	return <BaseFaqsSection FAQs={FAQs} {...rest} />
}
